import {GraphQLClient} from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import {gql} from '@shopify/hydrogen';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: number;
  JSON: any;
};

export type BeautyConsultantInputProps = {
  email: Scalars['String'];
  english: Scalars['Int'];
  experience: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  legalStatus: Scalars['String'];
  mobileNumber: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  skills: Scalars['String'];
  socialHandle?: InputMaybe<Scalars['String']>;
  workType: Scalars['String'];
};

export type ContactUsInputProps = {
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  subject: Scalars['String'];
};

export type DateOnly = {
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type IAppointment = {
  __typename?: 'IAppointment';
  Booking: IBooking;
  CompletionForm?: Maybe<ICompletionForm>;
  Consultant: IConsultant;
  Expenses: Array<Maybe<IExpense>>;
  bookingId: Scalars['String'];
  consultantId: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  scheduledAt: Scalars['Date'];
  scheduledEndAt: Scalars['Date'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IAppointmentCreateInput = {
  bookingId: Scalars['String'];
  consultantId: Scalars['String'];
  scheduledAt: Scalars['Date'];
  scheduledEndAt: Scalars['Date'];
};

export type IAppointmentUpdateInput = {
  bookingId: Scalars['String'];
  consultantId: Scalars['String'];
  scheduledAt: Scalars['Date'];
  scheduledEndAt: Scalars['Date'];
};

export type IBooking = {
  __typename?: 'IBooking';
  Appointment?: Maybe<IAppointment>;
  BookingExtraAddon: Array<IBookingExtraAddon>;
  Customer?: Maybe<ICustomer>;
  ShopifyProduct?: Maybe<IShopifyProduct>;
  ShopifyProductVariant?: Maybe<IShopifyProductVariant>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  customerId?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  firstName?: Maybe<Scalars['String']>;
  fullfillmentStatus?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  province?: Maybe<Scalars['String']>;
  scheduledAt: Scalars['Date'];
  shopifyId: Scalars['String'];
  shopifyItemId?: Maybe<Scalars['String']>;
  shopifyItemProductId?: Maybe<Scalars['String']>;
  shopifyItemProductVariantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IBookingCreateInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Float']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullfillmentStatus?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  province?: InputMaybe<Scalars['String']>;
  scheduledAt: Scalars['Date'];
  shopifyId: Scalars['String'];
  shopifyItemId?: InputMaybe<Scalars['String']>;
  shopifyItemProductId?: InputMaybe<Scalars['String']>;
  shopifyItemProductVariantId?: InputMaybe<Scalars['String']>;
};

export type IBookingExtraAddon = {
  __typename?: 'IBookingExtraAddon';
  addon: Scalars['String'];
  lineItemId: Scalars['String'];
};

export type IBookingUpdateInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Float']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullfillmentStatus?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  province?: InputMaybe<Scalars['String']>;
  scheduledAt: Scalars['Date'];
  shopifyId: Scalars['String'];
  shopifyItemId?: InputMaybe<Scalars['String']>;
  shopifyItemProductId?: InputMaybe<Scalars['String']>;
  shopifyItemProductVariantId?: InputMaybe<Scalars['String']>;
};

export type ICompletionForm = {
  __typename?: 'ICompletionForm';
  appointmentId: Scalars['String'];
  clientPreferences: Scalars['String'];
  imageUrls: Array<Scalars['String']>;
  notes: Scalars['String'];
};

export type IConsultant = {
  __typename?: 'IConsultant';
  Appointment: Array<IAppointment>;
  User: IUser;
  availableForZones: Array<IZoneIdentifier>;
  createdAt: Scalars['Date'];
  hasLinkedGoogleCalendar: Scalars['Boolean'];
  homeZones: Array<IZoneIdentifier>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
  userId: Scalars['String'];
};

export type ICustomer = {
  __typename?: 'ICustomer';
  Booking: Array<IBooking>;
  User: IUser;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  preferences?: Maybe<Scalars['JSON']>;
  shopifyId: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  userId: Scalars['String'];
};

export type ICustomerAuth = {
  __typename?: 'ICustomerAuth';
  access_token: Scalars['String'];
  shopifyCustomerAccessToken: ShopifyCustomerAccessToken;
};

export type ICustomerAuthInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type ICustomerUpdateInput = {
  preferences?: InputMaybe<Scalars['JSON']>;
};

export type ICustomerUserCreateInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ICustomerUserUpdateInput = {
  birthDate?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<IGender>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type IExpense = {
  __typename?: 'IExpense';
  appointmentId: Scalars['String'];
  createdAt: Scalars['Date'];
  expenseText: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
};

export enum IGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Others = 'OTHERS',
}

export type ILoopQueryPaginationResponse = {
  __typename?: 'ILoopQueryPaginationResponse';
  data: Scalars['String'];
  pagination?: Maybe<IPagination>;
};

export type ILoopQueryResponse = {
  __typename?: 'ILoopQueryResponse';
  data: Scalars['String'];
};

export type IPagination = {
  __typename?: 'IPagination';
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type IResetCustomerPasswordInput = {
  password: Scalars['String'];
  resetToken: Scalars['String'];
  shopifyId: Scalars['String'];
};

export enum IRole {
  Admin = 'ADMIN',
  Consultant = 'CONSULTANT',
  Customer = 'CUSTOMER',
  Manager = 'MANAGER',
}

export type ISelectedOption = {
  __typename?: 'ISelectedOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type IShopifyProduct = {
  __typename?: 'IShopifyProduct';
  ShopifyProductOption: Array<IShopifyProductOption>;
  ShopifyProductVariant: Array<IShopifyProductVariant>;
  handle: Scalars['String'];
  id: Scalars['String'];
  timesaversComponents: Array<Maybe<ITimesaversComponent>>;
  title: Scalars['String'];
};

export type IShopifyProductOption = {
  __typename?: 'IShopifyProductOption';
  id: Scalars['String'];
  name: Scalars['String'];
  position: Scalars['Int'];
  values: Array<Scalars['String']>;
};

export type IShopifyProductVariant = {
  __typename?: 'IShopifyProductVariant';
  ShopifyProduct: IShopifyProduct;
  bookable: Scalars['Boolean'];
  consultants: Array<IConsultant>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  price: Scalars['String'];
  selectedOptions: Array<ISelectedOption>;
  shopifyProductId: Scalars['String'];
  title: Scalars['String'];
};

export type IShopifyProductVariantTimeslotsInput = {
  date: DateOnly;
  id: Scalars['ID'];
  postcode: Scalars['String'];
};

export type ITimesaversAddonOption = {
  __typename?: 'ITimesaversAddonOption';
  enabledValues: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type ITimesaversComponent = {
  __typename?: 'ITimesaversComponent';
  componentIndex: Scalars['Int'];
  componentName?: Maybe<Scalars['String']>;
  componentProducts: Array<ITimesaversComponentProduct>;
};

export type ITimesaversComponentProduct = {
  __typename?: 'ITimesaversComponentProduct';
  addonOptions: Array<ITimesaversAddonOption>;
  enabledVariants: Array<IShopifyProductVariant>;
  id: Scalars['String'];
  shopifyProduct: IShopifyProduct;
};

export type ITimeslotSurgeFee = {
  __typename?: 'ITimeslotSurgeFee';
  amount: Scalars['String'];
  currencyCode: Scalars['String'];
  level: Scalars['Int'];
  variantShopifyId: Scalars['String'];
};

export type IUser = {
  __typename?: 'IUser';
  Consultant?: Maybe<IConsultant>;
  Customer?: Maybe<ICustomer>;
  UserProfile?: Maybe<IUserProfile>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  role: IRole;
  updatedAt?: Maybe<Scalars['Date']>;
  username: Scalars['String'];
};

export type IUserProfile = {
  __typename?: 'IUserProfile';
  birthDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<IGender>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IVariantTimeslot = {
  __typename?: 'IVariantTimeslot';
  consultantIds: Array<Scalars['String']>;
  dateTime: Scalars['Date'];
  surgeFee?: Maybe<ITimeslotSurgeFee>;
  unavailable: Scalars['Boolean'];
};

export type IZoneIdentifier = {
  __typename?: 'IZoneIdentifier';
  majorId: Scalars['String'];
  minorId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  appointmentCreate: IAppointment;
  appointmentDelete?: Maybe<IAppointment>;
  appointmentUpdate?: Maybe<IAppointment>;
  authLoginCustomer: ICustomerAuth;
  bookingCreate: IBooking;
  bookingDelete?: Maybe<IBooking>;
  bookingUpdate?: Maybe<IBooking>;
  completeSsoLogin: ShopifyCustomerAccessToken;
  customerGenerateActivationUrlByUsername: Scalars['String'];
  customerUpdate?: Maybe<ICustomer>;
  customerUserCreate: ICustomerAuth;
  customerUserUpdate?: Maybe<IUser>;
  resetCustomerPassword: ShopifyCustomerAccessToken;
  sendBeautyConsultantEmail: Scalars['Boolean'];
  sendContactEmail: Scalars['Boolean'];
  subscriptionCancel?: Maybe<Scalars['String']>;
  subscriptionChargeNow?: Maybe<Scalars['String']>;
  subscriptionEditDeliveryInterval?: Maybe<Scalars['String']>;
  subscriptionSkipNextOrder?: Maybe<Scalars['String']>;
  subscriptionSwapLine?: Maybe<Scalars['String']>;
  updateSsoPasswordIfNecessary: Scalars['Boolean'];
};

export type MutationAppointmentCreateArgs = {
  input: IAppointmentCreateInput;
};

export type MutationAppointmentDeleteArgs = {
  id: Scalars['ID'];
};

export type MutationAppointmentUpdateArgs = {
  input: IAppointmentUpdateInput;
};

export type MutationAuthLoginCustomerArgs = {
  input: ICustomerAuthInput;
};

export type MutationBookingCreateArgs = {
  input: IBookingCreateInput;
};

export type MutationBookingDeleteArgs = {
  id: Scalars['ID'];
};

export type MutationBookingUpdateArgs = {
  input: IBookingUpdateInput;
};

export type MutationCompleteSsoLoginArgs = {
  shopifyPassword: Scalars['String'];
};

export type MutationCustomerGenerateActivationUrlByUsernameArgs = {
  username: Scalars['String'];
};

export type MutationCustomerUpdateArgs = {
  input: ICustomerUpdateInput;
};

export type MutationCustomerUserCreateArgs = {
  input: ICustomerUserCreateInput;
};

export type MutationCustomerUserUpdateArgs = {
  input: ICustomerUserUpdateInput;
};

export type MutationResetCustomerPasswordArgs = {
  input: IResetCustomerPasswordInput;
};

export type MutationSendBeautyConsultantEmailArgs = {
  input: BeautyConsultantInputProps;
};

export type MutationSendContactEmailArgs = {
  input: ContactUsInputProps;
};

export type MutationSubscriptionCancelArgs = {
  id: Scalars['String'];
};

export type MutationSubscriptionChargeNowArgs = {
  id: Scalars['String'];
};

export type MutationSubscriptionEditDeliveryIntervalArgs = {
  delivery_interval: Scalars['String'];
  delivery_interval_count: Scalars['String'];
  id: Scalars['String'];
};

export type MutationSubscriptionSkipNextOrderArgs = {
  id: Scalars['String'];
};

export type MutationSubscriptionSwapLineArgs = {
  id: Scalars['String'];
  line_graphql_id: Scalars['String'];
  new_variant_shopify_id: Scalars['String'];
};

export type MutationUpdateSsoPasswordIfNecessaryArgs = {
  shopifyPassword: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  appointment?: Maybe<IAppointment>;
  appointmentByConsultant: Array<IAppointment>;
  appointments: Array<IAppointment>;
  booking?: Maybe<IBooking>;
  bookings: Array<IBooking>;
  cancellationReasons?: Maybe<ILoopQueryResponse>;
  consultantsAvailableForPostcode: Array<IConsultant>;
  customer?: Maybe<ICustomer>;
  hasShopifyPassword: Scalars['Boolean'];
  postcode: Scalars['String'];
  shopifyProduct?: Maybe<IShopifyProduct>;
  shopifyProductVariant?: Maybe<IShopifyProductVariant>;
  shopifyProductVariantTimeslots: Array<IVariantTimeslot>;
  shopifyProductVariants: Array<IShopifyProductVariant>;
  shopifyProducts: Array<IShopifyProduct>;
  shopifyProductsForIds: Array<IShopifyProduct>;
  subscriberReadDeliveryIntervals?: Maybe<ILoopQueryResponse>;
  subscriptionOrderHistory?: Maybe<ILoopQueryPaginationResponse>;
  subscriptions?: Maybe<ILoopQueryPaginationResponse>;
  user?: Maybe<IUser>;
  userByUsername?: Maybe<IUser>;
};

export type QueryAppointmentArgs = {
  id: Scalars['ID'];
};

export type QueryAppointmentByConsultantArgs = {
  consultantId: Scalars['String'];
};

export type QueryBookingArgs = {
  id: Scalars['ID'];
};

export type QueryConsultantsAvailableForPostcodeArgs = {
  postcode: Scalars['String'];
};

export type QueryCustomerArgs = {
  shopifyId: Scalars['String'];
};

export type QueryPostcodeArgs = {
  position: Array<Scalars['Float']>;
};

export type QueryShopifyProductArgs = {
  id: Scalars['String'];
};

export type QueryShopifyProductVariantArgs = {
  id: Scalars['String'];
};

export type QueryShopifyProductVariantTimeslotsArgs = {
  input: IShopifyProductVariantTimeslotsInput;
};

export type QueryShopifyProductVariantsArgs = {
  shopifyProductId?: InputMaybe<Scalars['String']>;
};

export type QueryShopifyProductsForIdsArgs = {
  ids: Array<Scalars['String']>;
};

export type QuerySubscriberReadDeliveryIntervalsArgs = {
  id: Scalars['String'];
};

export type QuerySubscriptionOrderHistoryArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type QueryUserByUsernameArgs = {
  username: Scalars['String'];
};

export type ShopifyCustomerAccessToken = {
  __typename?: 'ShopifyCustomerAccessToken';
  accessToken: Scalars['String'];
  expiresAt: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  appointmentCreated?: Maybe<IAppointment>;
  appointmentDeleted?: Maybe<IAppointment>;
  appointmentUpdated?: Maybe<IAppointment>;
  bookingCreated?: Maybe<IBooking>;
  bookingDeleted?: Maybe<IBooking>;
  bookingUpdated?: Maybe<IBooking>;
};

export type AuthLoginCustomerMutationVariables = Exact<{
  input: ICustomerAuthInput;
}>;

export type AuthLoginCustomerMutation = {
  __typename?: 'Mutation';
  authLoginCustomer: {
    __typename?: 'ICustomerAuth';
    access_token: string;
    shopifyCustomerAccessToken: {
      __typename?: 'ShopifyCustomerAccessToken';
      accessToken: string;
      expiresAt: string;
    };
  };
};

export type BookingByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BookingByIdQuery = {
  __typename?: 'Query';
  booking?: {
    __typename?: 'IBooking';
    id: string;
    shopifyId: string;
    orderName?: string | null;
    shopifyItemId?: string | null;
    shopifyItemProductId?: string | null;
    shopifyItemProductVariantId?: string | null;
    name?: string | null;
    price?: number | null;
    discount?: number | null;
    fullfillmentStatus?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    province?: string | null;
    postalCode?: string | null;
    customerId?: string | null;
    createdAt: number;
    updatedAt?: number | null;
    scheduledAt: number;
    Appointment?: {
      __typename?: 'IAppointment';
      id: string;
      bookingId: string;
      consultantId: string;
      scheduledAt: number;
      scheduledEndAt: number;
      createdAt: number;
      updatedAt?: number | null;
      Consultant: {
        __typename?: 'IConsultant';
        id: string;
        userId: string;
        createdAt: number;
        updatedAt?: number | null;
        User: {
          __typename?: 'IUser';
          id: string;
          username: string;
          role: IRole;
          createdAt: number;
          updatedAt?: number | null;
          UserProfile?: {
            __typename?: 'IUserProfile';
            firstName?: string | null;
            lastName?: string | null;
            email?: string | null;
            phoneNumber?: string | null;
            gender?: IGender | null;
            birthDate?: number | null;
          } | null;
        };
      };
    } | null;
  } | null;
};

export type BookingCreateMutationVariables = Exact<{
  input: IBookingCreateInput;
}>;

export type BookingCreateMutation = {
  __typename?: 'Mutation';
  bookingCreate: {
    __typename?: 'IBooking';
    id: string;
    shopifyId: string;
    orderName?: string | null;
    shopifyItemId?: string | null;
    shopifyItemProductId?: string | null;
    shopifyItemProductVariantId?: string | null;
    name?: string | null;
    price?: number | null;
    discount?: number | null;
    fullfillmentStatus?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    province?: string | null;
    postalCode?: string | null;
    customerId?: string | null;
    createdAt: number;
    updatedAt?: number | null;
    scheduledAt: number;
    Appointment?: {
      __typename?: 'IAppointment';
      id: string;
      bookingId: string;
      consultantId: string;
      scheduledAt: number;
      scheduledEndAt: number;
      createdAt: number;
      updatedAt?: number | null;
      Consultant: {
        __typename?: 'IConsultant';
        id: string;
        userId: string;
        createdAt: number;
        updatedAt?: number | null;
        User: {
          __typename?: 'IUser';
          id: string;
          username: string;
          role: IRole;
          createdAt: number;
          updatedAt?: number | null;
          UserProfile?: {
            __typename?: 'IUserProfile';
            firstName?: string | null;
            lastName?: string | null;
            email?: string | null;
            phoneNumber?: string | null;
            gender?: IGender | null;
            birthDate?: number | null;
          } | null;
        };
      };
    } | null;
  };
};

export type BookingUpdateMutationVariables = Exact<{
  input: IBookingUpdateInput;
}>;

export type BookingUpdateMutation = {
  __typename?: 'Mutation';
  bookingUpdate?: {
    __typename?: 'IBooking';
    id: string;
    shopifyId: string;
    orderName?: string | null;
    shopifyItemId?: string | null;
    shopifyItemProductId?: string | null;
    shopifyItemProductVariantId?: string | null;
    name?: string | null;
    price?: number | null;
    discount?: number | null;
    fullfillmentStatus?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    province?: string | null;
    postalCode?: string | null;
    customerId?: string | null;
    createdAt: number;
    updatedAt?: number | null;
    scheduledAt: number;
    Appointment?: {
      __typename?: 'IAppointment';
      id: string;
      bookingId: string;
      consultantId: string;
      scheduledAt: number;
      scheduledEndAt: number;
      createdAt: number;
      updatedAt?: number | null;
      Consultant: {
        __typename?: 'IConsultant';
        id: string;
        userId: string;
        createdAt: number;
        updatedAt?: number | null;
        User: {
          __typename?: 'IUser';
          id: string;
          username: string;
          role: IRole;
          createdAt: number;
          updatedAt?: number | null;
          UserProfile?: {
            __typename?: 'IUserProfile';
            firstName?: string | null;
            lastName?: string | null;
            email?: string | null;
            phoneNumber?: string | null;
            gender?: IGender | null;
            birthDate?: number | null;
          } | null;
        };
      };
    } | null;
  } | null;
};

export type BookingsQueryVariables = Exact<{[key: string]: never}>;

export type BookingsQuery = {
  __typename?: 'Query';
  bookings: Array<{
    __typename?: 'IBooking';
    id: string;
    shopifyId: string;
    orderName?: string | null;
    shopifyItemId?: string | null;
    shopifyItemProductId?: string | null;
    shopifyItemProductVariantId?: string | null;
    name?: string | null;
    price?: number | null;
    discount?: number | null;
    fullfillmentStatus?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    province?: string | null;
    postalCode?: string | null;
    customerId?: string | null;
    scheduledAt: number;
    createdAt: number;
    updatedAt?: number | null;
    Appointment?: {
      __typename?: 'IAppointment';
      scheduledAt: number;
      Consultant: {
        __typename?: 'IConsultant';
        User: {
          __typename?: 'IUser';
          UserProfile?: {
            __typename?: 'IUserProfile';
            firstName?: string | null;
            lastName?: string | null;
            email?: string | null;
            phoneNumber?: string | null;
            gender?: IGender | null;
            birthDate?: number | null;
          } | null;
        };
      };
    } | null;
  }>;
};

export type CompleteSsoLoginMutationVariables = Exact<{
  shopifyPassword: Scalars['String'];
}>;

export type CompleteSsoLoginMutation = {
  __typename?: 'Mutation';
  completeSsoLogin: {
    __typename?: 'ShopifyCustomerAccessToken';
    accessToken: string;
    expiresAt: string;
  };
};

export type ConsultantsAvailableForPostcodeQueryVariables = Exact<{
  postcode: Scalars['String'];
}>;

export type ConsultantsAvailableForPostcodeQuery = {
  __typename?: 'Query';
  consultantsAvailableForPostcode: Array<{
    __typename?: 'IConsultant';
    id: string;
    userId: string;
    createdAt: number;
    updatedAt?: number | null;
    User: {
      __typename?: 'IUser';
      id: string;
      username: string;
      role: IRole;
      createdAt: number;
      updatedAt?: number | null;
      UserProfile?: {
        __typename?: 'IUserProfile';
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        gender?: IGender | null;
        birthDate?: number | null;
      } | null;
    };
  }>;
};

export type CustomerGenerateActivationUrlByUsernameMutationVariables = Exact<{
  username: Scalars['String'];
}>;

export type CustomerGenerateActivationUrlByUsernameMutation = {
  __typename?: 'Mutation';
  customerGenerateActivationUrlByUsername: string;
};

export type CustomerByShopifyIdQueryVariables = Exact<{
  shopifyId: Scalars['String'];
}>;

export type CustomerByShopifyIdQuery = {
  __typename?: 'Query';
  customer?: {
    __typename?: 'ICustomer';
    id: string;
    shopifyId: string;
    userId: string;
    preferences?: any | null;
    createdAt: number;
    updatedAt?: number | null;
  } | null;
};

export type CustomerUpdateMutationVariables = Exact<{
  input: ICustomerUpdateInput;
}>;

export type CustomerUpdateMutation = {
  __typename?: 'Mutation';
  customerUpdate?: {
    __typename?: 'ICustomer';
    id: string;
    shopifyId: string;
    userId: string;
    preferences?: any | null;
    createdAt: number;
    updatedAt?: number | null;
  } | null;
};

export type CustomerUserCreateMutationVariables = Exact<{
  input: ICustomerUserCreateInput;
}>;

export type CustomerUserCreateMutation = {
  __typename?: 'Mutation';
  customerUserCreate: {
    __typename?: 'ICustomerAuth';
    access_token: string;
    shopifyCustomerAccessToken: {
      __typename?: 'ShopifyCustomerAccessToken';
      accessToken: string;
      expiresAt: string;
    };
  };
};

export type CustomerUserUpdateMutationVariables = Exact<{
  input: ICustomerUserUpdateInput;
}>;

export type CustomerUserUpdateMutation = {
  __typename?: 'Mutation';
  customerUserUpdate?: {
    __typename?: 'IUser';
    id: string;
    username: string;
    role: IRole;
    createdAt: number;
    updatedAt?: number | null;
    UserProfile?: {
      __typename?: 'IUserProfile';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      gender?: IGender | null;
      birthDate?: number | null;
    } | null;
    Customer?: {
      __typename?: 'ICustomer';
      id: string;
      shopifyId: string;
      userId: string;
      preferences?: any | null;
      createdAt: number;
      updatedAt?: number | null;
    } | null;
  } | null;
};

export type GetPostcodeQueryVariables = Exact<{
  position: Array<Scalars['Float']> | Scalars['Float'];
}>;

export type GetPostcodeQuery = {__typename?: 'Query'; postcode: string};

export type HasShopifyPasswordQueryVariables = Exact<{[key: string]: never}>;

export type HasShopifyPasswordQuery = {
  __typename?: 'Query';
  hasShopifyPassword: boolean;
};

export type ResetCustomerPasswordMutationVariables = Exact<{
  input: IResetCustomerPasswordInput;
}>;

export type ResetCustomerPasswordMutation = {
  __typename?: 'Mutation';
  resetCustomerPassword: {
    __typename?: 'ShopifyCustomerAccessToken';
    accessToken: string;
    expiresAt: string;
  };
};

export type SendBeautyConsultantEmailMutationVariables = Exact<{
  input: BeautyConsultantInputProps;
}>;

export type SendBeautyConsultantEmailMutation = {
  __typename?: 'Mutation';
  sendBeautyConsultantEmail: boolean;
};

export type SendContactEmailMutationVariables = Exact<{
  input: ContactUsInputProps;
}>;

export type SendContactEmailMutation = {
  __typename?: 'Mutation';
  sendContactEmail: boolean;
};

export type ShopifyProductVariantByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ShopifyProductVariantByIdQuery = {
  __typename?: 'Query';
  shopifyProductVariant?: {
    __typename?: 'IShopifyProductVariant';
    id: string;
    shopifyProductId: string;
    title: string;
    price: string;
    bookable: boolean;
    duration?: number | null;
  } | null;
};

export type ShopifyProductVariantTimeslotsQueryVariables = Exact<{
  input: IShopifyProductVariantTimeslotsInput;
}>;

export type ShopifyProductVariantTimeslotsQuery = {
  __typename?: 'Query';
  shopifyProductVariantTimeslots: Array<{
    __typename?: 'IVariantTimeslot';
    dateTime: number;
    consultantIds: Array<string>;
    surgeFee?: {
      __typename?: 'ITimeslotSurgeFee';
      amount: string;
      currencyCode: string;
      level: number;
      variantShopifyId: string;
    } | null;
  }>;
};

export type ShopifyProductsQueryVariables = Exact<{[key: string]: never}>;

export type ShopifyProductsQuery = {
  __typename?: 'Query';
  shopifyProducts: Array<{
    __typename?: 'IShopifyProduct';
    id: string;
    title: string;
    handle: string;
    ShopifyProductVariant: Array<{
      __typename?: 'IShopifyProductVariant';
      id: string;
      shopifyProductId: string;
      title: string;
      price: string;
      bookable: boolean;
      duration?: number | null;
    }>;
  }>;
};

export type SubscriptionCancelMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type SubscriptionCancelMutation = {
  __typename?: 'Mutation';
  subscriptionCancel?: string | null;
};

export type SubscriptionChargeNowMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type SubscriptionChargeNowMutation = {
  __typename?: 'Mutation';
  subscriptionChargeNow?: string | null;
};

export type SubscriptionEditDeliveryIntervalMutationVariables = Exact<{
  id: Scalars['String'];
  delivery_interval: Scalars['String'];
  delivery_interval_count: Scalars['String'];
}>;

export type SubscriptionEditDeliveryIntervalMutation = {
  __typename?: 'Mutation';
  subscriptionEditDeliveryInterval?: string | null;
};

export type SubscriptionOrderHistoryQueryVariables = Exact<{
  id: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type SubscriptionOrderHistoryQuery = {
  __typename?: 'Query';
  subscriptionOrderHistory?: {
    __typename?: 'ILoopQueryPaginationResponse';
    data: string;
    pagination?: {
      __typename?: 'IPagination';
      total?: number | null;
      totalPages?: number | null;
      page?: number | null;
      limit?: number | null;
    } | null;
  } | null;
};

export type SubscriptionReadDeliveryIntervalsQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type SubscriptionReadDeliveryIntervalsQuery = {
  __typename?: 'Query';
  subscriberReadDeliveryIntervals?: {
    __typename?: 'ILoopQueryResponse';
    data: string;
  } | null;
};

export type SubscriptionSkipNextOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type SubscriptionSkipNextOrderMutation = {
  __typename?: 'Mutation';
  subscriptionSkipNextOrder?: string | null;
};

export type SubscriptionSwapLineMutationVariables = Exact<{
  id: Scalars['String'];
  line_graphql_id: Scalars['String'];
  new_variant_shopify_id: Scalars['String'];
}>;

export type SubscriptionSwapLineMutation = {
  __typename?: 'Mutation';
  subscriptionSwapLine?: string | null;
};

export type SubscriptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type SubscriptionsQuery = {
  __typename?: 'Query';
  subscriptions?: {
    __typename?: 'ILoopQueryPaginationResponse';
    data: string;
    pagination?: {
      __typename?: 'IPagination';
      total?: number | null;
      totalPages?: number | null;
      page?: number | null;
      limit?: number | null;
    } | null;
  } | null;
};

export type UpdateSsoPasswordIfNecessaryMutationVariables = Exact<{
  shopifyPassword: Scalars['String'];
}>;

export type UpdateSsoPasswordIfNecessaryMutation = {
  __typename?: 'Mutation';
  updateSsoPasswordIfNecessary: boolean;
};

export type UserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UserByIdQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'IUser';
    id: string;
    username: string;
    role: IRole;
    createdAt: number;
    updatedAt?: number | null;
    UserProfile?: {
      __typename?: 'IUserProfile';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      gender?: IGender | null;
      birthDate?: number | null;
    } | null;
    Customer?: {
      __typename?: 'ICustomer';
      id: string;
      shopifyId: string;
      userId: string;
      preferences?: any | null;
      createdAt: number;
      updatedAt?: number | null;
    } | null;
  } | null;
};

export type UserByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;

export type UserByUsernameQuery = {
  __typename?: 'Query';
  userByUsername?: {
    __typename?: 'IUser';
    id: string;
    username: string;
    role: IRole;
    createdAt: number;
    updatedAt?: number | null;
    UserProfile?: {
      __typename?: 'IUserProfile';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      gender?: IGender | null;
      birthDate?: number | null;
    } | null;
    Customer?: {
      __typename?: 'ICustomer';
      id: string;
      shopifyId: string;
      userId: string;
      preferences?: any | null;
      createdAt: number;
      updatedAt?: number | null;
    } | null;
  } | null;
};

export type BaseBookingFragment = {
  __typename?: 'IBooking';
  id: string;
  shopifyId: string;
  orderName?: string | null;
  shopifyItemId?: string | null;
  shopifyItemProductId?: string | null;
  shopifyItemProductVariantId?: string | null;
  name?: string | null;
  price?: number | null;
  discount?: number | null;
  fullfillmentStatus?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  province?: string | null;
  postalCode?: string | null;
  customerId?: string | null;
  scheduledAt: number;
  createdAt: number;
  updatedAt?: number | null;
};

export type IAppointmentFragment = {
  __typename?: 'IAppointment';
  id: string;
  bookingId: string;
  consultantId: string;
  scheduledAt: number;
  scheduledEndAt: number;
  createdAt: number;
  updatedAt?: number | null;
  Consultant: {
    __typename?: 'IConsultant';
    id: string;
    userId: string;
    createdAt: number;
    updatedAt?: number | null;
    User: {
      __typename?: 'IUser';
      id: string;
      username: string;
      role: IRole;
      createdAt: number;
      updatedAt?: number | null;
      UserProfile?: {
        __typename?: 'IUserProfile';
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        gender?: IGender | null;
        birthDate?: number | null;
      } | null;
    };
  };
};

export type IBookingFragment = {
  __typename?: 'IBooking';
  id: string;
  shopifyId: string;
  orderName?: string | null;
  shopifyItemId?: string | null;
  shopifyItemProductId?: string | null;
  shopifyItemProductVariantId?: string | null;
  name?: string | null;
  price?: number | null;
  discount?: number | null;
  fullfillmentStatus?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  province?: string | null;
  postalCode?: string | null;
  customerId?: string | null;
  createdAt: number;
  updatedAt?: number | null;
  scheduledAt: number;
  Appointment?: {
    __typename?: 'IAppointment';
    id: string;
    bookingId: string;
    consultantId: string;
    scheduledAt: number;
    scheduledEndAt: number;
    createdAt: number;
    updatedAt?: number | null;
    Consultant: {
      __typename?: 'IConsultant';
      id: string;
      userId: string;
      createdAt: number;
      updatedAt?: number | null;
      User: {
        __typename?: 'IUser';
        id: string;
        username: string;
        role: IRole;
        createdAt: number;
        updatedAt?: number | null;
        UserProfile?: {
          __typename?: 'IUserProfile';
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          gender?: IGender | null;
          birthDate?: number | null;
        } | null;
      };
    };
  } | null;
};

export type IConsultantFragment = {
  __typename?: 'IConsultant';
  id: string;
  userId: string;
  createdAt: number;
  updatedAt?: number | null;
  User: {
    __typename?: 'IUser';
    id: string;
    username: string;
    role: IRole;
    createdAt: number;
    updatedAt?: number | null;
    UserProfile?: {
      __typename?: 'IUserProfile';
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      gender?: IGender | null;
      birthDate?: number | null;
    } | null;
  };
};

export type ICustomerFragment = {
  __typename?: 'ICustomer';
  id: string;
  shopifyId: string;
  userId: string;
  preferences?: any | null;
  createdAt: number;
  updatedAt?: number | null;
};

export type ICustomerAuthFragment = {
  __typename?: 'ICustomerAuth';
  access_token: string;
  shopifyCustomerAccessToken: {
    __typename?: 'ShopifyCustomerAccessToken';
    accessToken: string;
    expiresAt: string;
  };
};

export type IPaginationFragment = {
  __typename?: 'IPagination';
  total?: number | null;
  totalPages?: number | null;
  page?: number | null;
  limit?: number | null;
};

export type IShopifyProductFragment = {
  __typename?: 'IShopifyProduct';
  id: string;
  title: string;
  handle: string;
  ShopifyProductVariant: Array<{
    __typename?: 'IShopifyProductVariant';
    id: string;
    shopifyProductId: string;
    title: string;
    price: string;
    bookable: boolean;
    duration?: number | null;
  }>;
};

export type IShopifyProductVariantFragment = {
  __typename?: 'IShopifyProductVariant';
  id: string;
  shopifyProductId: string;
  title: string;
  price: string;
  bookable: boolean;
  duration?: number | null;
};

export type ILoopQueryPaginationResponseFragment = {
  __typename?: 'ILoopQueryPaginationResponse';
  data: string;
  pagination?: {
    __typename?: 'IPagination';
    total?: number | null;
    totalPages?: number | null;
    page?: number | null;
    limit?: number | null;
  } | null;
};

export type ILoopQueryResponseFragment = {
  __typename?: 'ILoopQueryResponse';
  data: string;
};

export type IUserFragment = {
  __typename?: 'IUser';
  id: string;
  username: string;
  role: IRole;
  createdAt: number;
  updatedAt?: number | null;
  UserProfile?: {
    __typename?: 'IUserProfile';
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    gender?: IGender | null;
    birthDate?: number | null;
  } | null;
  Customer?: {
    __typename?: 'ICustomer';
    id: string;
    shopifyId: string;
    userId: string;
    preferences?: any | null;
    createdAt: number;
    updatedAt?: number | null;
  } | null;
};

export type IUserProfileFragment = {
  __typename?: 'IUserProfile';
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  gender?: IGender | null;
  birthDate?: number | null;
};

export type IVariantTimeslotFragment = {
  __typename?: 'IVariantTimeslot';
  dateTime: number;
  consultantIds: Array<string>;
  surgeFee?: {
    __typename?: 'ITimeslotSurgeFee';
    amount: string;
    currencyCode: string;
    level: number;
    variantShopifyId: string;
  } | null;
};

export const BaseBookingFragmentDoc = gql`
  fragment BaseBooking on IBooking {
    id
    shopifyId
    orderName
    shopifyItemId
    shopifyItemProductId
    shopifyItemProductVariantId
    name
    price
    discount
    fullfillmentStatus
    address1
    address2
    city
    province
    postalCode
    customerId
    scheduledAt
    createdAt
    updatedAt
  }
`;
export const IConsultantFragmentDoc = gql`
  fragment IConsultant on IConsultant {
    id
    userId
    createdAt
    updatedAt
    User {
      id
      username
      role
      createdAt
      updatedAt
      UserProfile {
        firstName
        lastName
        email
        phoneNumber
        gender
        birthDate
      }
    }
  }
`;
export const IAppointmentFragmentDoc = gql`
  fragment IAppointment on IAppointment {
    id
    bookingId
    consultantId
    scheduledAt
    scheduledEndAt
    createdAt
    updatedAt
    Consultant {
      ...IConsultant
    }
  }
`;
export const IBookingFragmentDoc = gql`
  fragment IBooking on IBooking {
    id
    shopifyId
    orderName
    shopifyItemId
    shopifyItemProductId
    shopifyItemProductVariantId
    name
    price
    discount
    fullfillmentStatus
    address1
    address2
    city
    province
    postalCode
    customerId
    createdAt
    updatedAt
    scheduledAt
    Appointment {
      ...IAppointment
    }
  }
`;
export const ICustomerAuthFragmentDoc = gql`
  fragment ICustomerAuth on ICustomerAuth {
    access_token
    shopifyCustomerAccessToken {
      accessToken
      expiresAt
    }
  }
`;
export const IShopifyProductVariantFragmentDoc = gql`
  fragment IShopifyProductVariant on IShopifyProductVariant {
    id
    shopifyProductId
    title
    price
    bookable
    duration
  }
`;
export const IShopifyProductFragmentDoc = gql`
  fragment IShopifyProduct on IShopifyProduct {
    id
    title
    handle
    ShopifyProductVariant {
      ...IShopifyProductVariant
    }
  }
`;
export const IPaginationFragmentDoc = gql`
  fragment IPagination on IPagination {
    total
    totalPages
    page
    limit
  }
`;
export const ILoopQueryPaginationResponseFragmentDoc = gql`
  fragment ILoopQueryPaginationResponse on ILoopQueryPaginationResponse {
    data
    pagination {
      ...IPagination
    }
  }
`;
export const ILoopQueryResponseFragmentDoc = gql`
  fragment ILoopQueryResponse on ILoopQueryResponse {
    data
  }
`;
export const IUserProfileFragmentDoc = gql`
  fragment IUserProfile on IUserProfile {
    firstName
    lastName
    email
    phoneNumber
    gender
    birthDate
  }
`;
export const ICustomerFragmentDoc = gql`
  fragment ICustomer on ICustomer {
    id
    shopifyId
    userId
    preferences
    createdAt
    updatedAt
  }
`;
export const IUserFragmentDoc = gql`
  fragment IUser on IUser {
    id
    username
    role
    createdAt
    updatedAt
    UserProfile {
      ...IUserProfile
    }
    Customer {
      ...ICustomer
    }
  }
`;
export const IVariantTimeslotFragmentDoc = gql`
  fragment IVariantTimeslot on IVariantTimeslot {
    dateTime
    consultantIds
    surgeFee {
      amount
      currencyCode
      level
      variantShopifyId
    }
  }
`;
export const AuthLoginCustomerDocument = gql`
  mutation AuthLoginCustomer($input: ICustomerAuthInput!) {
    authLoginCustomer(input: $input) {
      ...ICustomerAuth
    }
  }
  ${ICustomerAuthFragmentDoc}
`;
export const BookingByIdDocument = gql`
  query BookingById($id: ID!) {
    booking(id: $id) {
      ...IBooking
    }
  }
  ${IBookingFragmentDoc}
  ${IAppointmentFragmentDoc}
  ${IConsultantFragmentDoc}
`;
export const BookingCreateDocument = gql`
  mutation BookingCreate($input: IBookingCreateInput!) {
    bookingCreate(input: $input) {
      ...IBooking
    }
  }
  ${IBookingFragmentDoc}
  ${IAppointmentFragmentDoc}
  ${IConsultantFragmentDoc}
`;
export const BookingUpdateDocument = gql`
  mutation BookingUpdate($input: IBookingUpdateInput!) {
    bookingUpdate(input: $input) {
      ...IBooking
    }
  }
  ${IBookingFragmentDoc}
  ${IAppointmentFragmentDoc}
  ${IConsultantFragmentDoc}
`;
export const BookingsDocument = gql`
  query Bookings {
    bookings {
      ...BaseBooking
      Appointment {
        scheduledAt
        Consultant {
          User {
            UserProfile {
              ...IUserProfile
            }
          }
        }
      }
    }
  }
  ${BaseBookingFragmentDoc}
  ${IUserProfileFragmentDoc}
`;
export const CompleteSsoLoginDocument = gql`
  mutation CompleteSsoLogin($shopifyPassword: String!) {
    completeSsoLogin(shopifyPassword: $shopifyPassword) {
      accessToken
      expiresAt
    }
  }
`;
export const ConsultantsAvailableForPostcodeDocument = gql`
  query ConsultantsAvailableForPostcode($postcode: String!) {
    consultantsAvailableForPostcode(postcode: $postcode) {
      ...IConsultant
    }
  }
  ${IConsultantFragmentDoc}
`;
export const CustomerGenerateActivationUrlByUsernameDocument = gql`
  mutation CustomerGenerateActivationUrlByUsername($username: String!) {
    customerGenerateActivationUrlByUsername(username: $username)
  }
`;
export const CustomerByShopifyIdDocument = gql`
  query CustomerByShopifyId($shopifyId: String!) {
    customer(shopifyId: $shopifyId) {
      ...ICustomer
    }
  }
  ${ICustomerFragmentDoc}
`;
export const CustomerUpdateDocument = gql`
  mutation CustomerUpdate($input: ICustomerUpdateInput!) {
    customerUpdate(input: $input) {
      ...ICustomer
    }
  }
  ${ICustomerFragmentDoc}
`;
export const CustomerUserCreateDocument = gql`
  mutation CustomerUserCreate($input: ICustomerUserCreateInput!) {
    customerUserCreate(input: $input) {
      ...ICustomerAuth
    }
  }
  ${ICustomerAuthFragmentDoc}
`;
export const CustomerUserUpdateDocument = gql`
  mutation CustomerUserUpdate($input: ICustomerUserUpdateInput!) {
    customerUserUpdate(input: $input) {
      ...IUser
    }
  }
  ${IUserFragmentDoc}
  ${IUserProfileFragmentDoc}
  ${ICustomerFragmentDoc}
`;
export const GetPostcodeDocument = gql`
  query GetPostcode($position: [Float!]!) {
    postcode(position: $position)
  }
`;
export const HasShopifyPasswordDocument = gql`
  query HasShopifyPassword {
    hasShopifyPassword
  }
`;
export const ResetCustomerPasswordDocument = gql`
  mutation resetCustomerPassword($input: IResetCustomerPasswordInput!) {
    resetCustomerPassword(input: $input) {
      accessToken
      expiresAt
    }
  }
`;
export const SendBeautyConsultantEmailDocument = gql`
  mutation SendBeautyConsultantEmail($input: BeautyConsultantInputProps!) {
    sendBeautyConsultantEmail(input: $input)
  }
`;
export const SendContactEmailDocument = gql`
  mutation SendContactEmail($input: ContactUsInputProps!) {
    sendContactEmail(input: $input)
  }
`;
export const ShopifyProductVariantByIdDocument = gql`
  query ShopifyProductVariantById($id: String!) {
    shopifyProductVariant(id: $id) {
      ...IShopifyProductVariant
    }
  }
  ${IShopifyProductVariantFragmentDoc}
`;
export const ShopifyProductVariantTimeslotsDocument = gql`
  query ShopifyProductVariantTimeslots(
    $input: IShopifyProductVariantTimeslotsInput!
  ) {
    shopifyProductVariantTimeslots(input: $input) {
      ...IVariantTimeslot
    }
  }
  ${IVariantTimeslotFragmentDoc}
`;
export const ShopifyProductsDocument = gql`
  query ShopifyProducts {
    shopifyProducts {
      ...IShopifyProduct
    }
  }
  ${IShopifyProductFragmentDoc}
  ${IShopifyProductVariantFragmentDoc}
`;
export const SubscriptionCancelDocument = gql`
  mutation SubscriptionCancel($id: String!) {
    subscriptionCancel(id: $id)
  }
`;
export const SubscriptionChargeNowDocument = gql`
  mutation SubscriptionChargeNow($id: String!) {
    subscriptionChargeNow(id: $id)
  }
`;
export const SubscriptionEditDeliveryIntervalDocument = gql`
  mutation SubscriptionEditDeliveryInterval(
    $id: String!
    $delivery_interval: String!
    $delivery_interval_count: String!
  ) {
    subscriptionEditDeliveryInterval(
      id: $id
      delivery_interval: $delivery_interval
      delivery_interval_count: $delivery_interval_count
    )
  }
`;
export const SubscriptionOrderHistoryDocument = gql`
  query SubscriptionOrderHistory($id: String!, $page: Int, $limit: Int) {
    subscriptionOrderHistory(id: $id, page: $page, limit: $limit) {
      ...ILoopQueryPaginationResponse
    }
  }
  ${ILoopQueryPaginationResponseFragmentDoc}
  ${IPaginationFragmentDoc}
`;
export const SubscriptionReadDeliveryIntervalsDocument = gql`
  query SubscriptionReadDeliveryIntervals($id: String!) {
    subscriberReadDeliveryIntervals(id: $id) {
      ...ILoopQueryResponse
    }
  }
  ${ILoopQueryResponseFragmentDoc}
`;
export const SubscriptionSkipNextOrderDocument = gql`
  mutation SubscriptionSkipNextOrder($id: String!) {
    subscriptionSkipNextOrder(id: $id)
  }
`;
export const SubscriptionSwapLineDocument = gql`
  mutation SubscriptionSwapLine(
    $id: String!
    $line_graphql_id: String!
    $new_variant_shopify_id: String!
  ) {
    subscriptionSwapLine(
      id: $id
      line_graphql_id: $line_graphql_id
      new_variant_shopify_id: $new_variant_shopify_id
    )
  }
`;
export const SubscriptionsDocument = gql`
  query Subscriptions($page: Int, $limit: Int) {
    subscriptions(page: $page, limit: $limit) {
      ...ILoopQueryPaginationResponse
    }
  }
  ${ILoopQueryPaginationResponseFragmentDoc}
  ${IPaginationFragmentDoc}
`;
export const SealSubscriptionsDocument = gql`
  query SealSubscriptions($page: Int, $limit: Int) {
    sealSubscriptions(page: $page, limit: $limit) {
      ...ILoopQueryPaginationResponse
    }
  }
  ${ILoopQueryPaginationResponseFragmentDoc}
  ${IPaginationFragmentDoc}
`;
export const UpdateSsoPasswordIfNecessaryDocument = gql`
  mutation updateSsoPasswordIfNecessary($shopifyPassword: String!) {
    updateSsoPasswordIfNecessary(shopifyPassword: $shopifyPassword)
  }
`;
export const UserByIdDocument = gql`
  query UserById($id: ID!) {
    user(id: $id) {
      ...IUser
    }
  }
  ${IUserFragmentDoc}
  ${IUserProfileFragmentDoc}
  ${ICustomerFragmentDoc}
`;
export const UserByUsernameDocument = gql`
  query UserByUsername($username: String!) {
    userByUsername(username: $username) {
      ...IUser
    }
  }
  ${IUserFragmentDoc}
  ${IUserProfileFragmentDoc}
  ${ICustomerFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    AuthLoginCustomer(
      variables: AuthLoginCustomerMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<AuthLoginCustomerMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AuthLoginCustomerMutation>(
            AuthLoginCustomerDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'AuthLoginCustomer',
        'mutation',
      );
    },
    BookingById(
      variables: BookingByIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<BookingByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<BookingByIdQuery>(BookingByIdDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'BookingById',
        'query',
      );
    },
    BookingCreate(
      variables: BookingCreateMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<BookingCreateMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<BookingCreateMutation>(
            BookingCreateDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'BookingCreate',
        'mutation',
      );
    },
    BookingUpdate(
      variables: BookingUpdateMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<BookingUpdateMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<BookingUpdateMutation>(
            BookingUpdateDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'BookingUpdate',
        'mutation',
      );
    },
    Bookings(
      variables?: BookingsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<BookingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<BookingsQuery>(BookingsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'Bookings',
        'query',
      );
    },
    CompleteSsoLogin(
      variables: CompleteSsoLoginMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CompleteSsoLoginMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CompleteSsoLoginMutation>(
            CompleteSsoLoginDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'CompleteSsoLogin',
        'mutation',
      );
    },
    ConsultantsAvailableForPostcode(
      variables: ConsultantsAvailableForPostcodeQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<ConsultantsAvailableForPostcodeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ConsultantsAvailableForPostcodeQuery>(
            ConsultantsAvailableForPostcodeDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'ConsultantsAvailableForPostcode',
        'query',
      );
    },
    CustomerGenerateActivationUrlByUsername(
      variables: CustomerGenerateActivationUrlByUsernameMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerGenerateActivationUrlByUsernameMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerGenerateActivationUrlByUsernameMutation>(
            CustomerGenerateActivationUrlByUsernameDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'CustomerGenerateActivationUrlByUsername',
        'mutation',
      );
    },
    CustomerByShopifyId(
      variables: CustomerByShopifyIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerByShopifyIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerByShopifyIdQuery>(
            CustomerByShopifyIdDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'CustomerByShopifyId',
        'query',
      );
    },
    CustomerUpdate(
      variables: CustomerUpdateMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerUpdateMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerUpdateMutation>(
            CustomerUpdateDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'CustomerUpdate',
        'mutation',
      );
    },
    CustomerUserCreate(
      variables: CustomerUserCreateMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerUserCreateMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerUserCreateMutation>(
            CustomerUserCreateDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'CustomerUserCreate',
        'mutation',
      );
    },
    CustomerUserUpdate(
      variables: CustomerUserUpdateMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerUserUpdateMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerUserUpdateMutation>(
            CustomerUserUpdateDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'CustomerUserUpdate',
        'mutation',
      );
    },
    GetPostcode(
      variables: GetPostcodeQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<GetPostcodeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPostcodeQuery>(GetPostcodeDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetPostcode',
        'query',
      );
    },
    HasShopifyPassword(
      variables?: HasShopifyPasswordQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<HasShopifyPasswordQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<HasShopifyPasswordQuery>(
            HasShopifyPasswordDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'HasShopifyPassword',
        'query',
      );
    },
    resetCustomerPassword(
      variables: ResetCustomerPasswordMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<ResetCustomerPasswordMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ResetCustomerPasswordMutation>(
            ResetCustomerPasswordDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'resetCustomerPassword',
        'mutation',
      );
    },
    SendBeautyConsultantEmail(
      variables: SendBeautyConsultantEmailMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SendBeautyConsultantEmailMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SendBeautyConsultantEmailMutation>(
            SendBeautyConsultantEmailDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SendBeautyConsultantEmail',
        'mutation',
      );
    },
    SendContactEmail(
      variables: SendContactEmailMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SendContactEmailMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SendContactEmailMutation>(
            SendContactEmailDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SendContactEmail',
        'mutation',
      );
    },
    ShopifyProductVariantById(
      variables: ShopifyProductVariantByIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<ShopifyProductVariantByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ShopifyProductVariantByIdQuery>(
            ShopifyProductVariantByIdDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'ShopifyProductVariantById',
        'query',
      );
    },
    ShopifyProductVariantTimeslots(
      variables: ShopifyProductVariantTimeslotsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<ShopifyProductVariantTimeslotsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ShopifyProductVariantTimeslotsQuery>(
            ShopifyProductVariantTimeslotsDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'ShopifyProductVariantTimeslots',
        'query',
      );
    },
    ShopifyProducts(
      variables?: ShopifyProductsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<ShopifyProductsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ShopifyProductsQuery>(
            ShopifyProductsDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'ShopifyProducts',
        'query',
      );
    },
    SubscriptionCancel(
      variables: SubscriptionCancelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionCancelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionCancelMutation>(
            SubscriptionCancelDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SubscriptionCancel',
        'mutation',
      );
    },
    SubscriptionChargeNow(
      variables: SubscriptionChargeNowMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionChargeNowMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionChargeNowMutation>(
            SubscriptionChargeNowDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SubscriptionChargeNow',
        'mutation',
      );
    },
    SubscriptionEditDeliveryInterval(
      variables: SubscriptionEditDeliveryIntervalMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionEditDeliveryIntervalMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionEditDeliveryIntervalMutation>(
            SubscriptionEditDeliveryIntervalDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SubscriptionEditDeliveryInterval',
        'mutation',
      );
    },
    SubscriptionOrderHistory(
      variables: SubscriptionOrderHistoryQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionOrderHistoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionOrderHistoryQuery>(
            SubscriptionOrderHistoryDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SubscriptionOrderHistory',
        'query',
      );
    },
    SubscriptionReadDeliveryIntervals(
      variables: SubscriptionReadDeliveryIntervalsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionReadDeliveryIntervalsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionReadDeliveryIntervalsQuery>(
            SubscriptionReadDeliveryIntervalsDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SubscriptionReadDeliveryIntervals',
        'query',
      );
    },
    SubscriptionSkipNextOrder(
      variables: SubscriptionSkipNextOrderMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionSkipNextOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionSkipNextOrderMutation>(
            SubscriptionSkipNextOrderDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SubscriptionSkipNextOrder',
        'mutation',
      );
    },
    SubscriptionSwapLine(
      variables: SubscriptionSwapLineMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionSwapLineMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionSwapLineMutation>(
            SubscriptionSwapLineDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'SubscriptionSwapLine',
        'mutation',
      );
    },
    Subscriptions(
      variables?: SubscriptionsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<SubscriptionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscriptionsQuery>(SubscriptionsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'Subscriptions',
        'query',
      );
    },
    updateSsoPasswordIfNecessary(
      variables: UpdateSsoPasswordIfNecessaryMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<UpdateSsoPasswordIfNecessaryMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateSsoPasswordIfNecessaryMutation>(
            UpdateSsoPasswordIfNecessaryDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'updateSsoPasswordIfNecessary',
        'mutation',
      );
    },
    UserById(
      variables: UserByIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<UserByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UserByIdQuery>(UserByIdDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'UserById',
        'query',
      );
    },
    UserByUsername(
      variables: UserByUsernameQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<UserByUsernameQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UserByUsernameQuery>(
            UserByUsernameDocument,
            variables,
            {...requestHeaders, ...wrappedRequestHeaders},
          ),
        'UserByUsername',
        'query',
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
